import React, { useState, useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLedger, removeLedger, addLedger } from "../features/ledgers/ledgerSlice";
import { API_URL } from "../config";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import CustomInput from "../components/Common/CustomInput";


function LedgerTable() {
	// Get the current year and set it as the default state
const currentYear = new Date().getFullYear();
const [year, setYear] = useState(currentYear);

const emptyRow = {
    type: "EXW",
    invoice_no: currentYear.toString(),
    date: new Date().toISOString().split('T')[0],
    booking_no: "",
    tara: "",
    container_no: "",
    seal_no: "",
    qty: "",
    material: "",
    supplier: "",
    supplier_po: "",
    supplier_nfe: "",
    supplier_pp: "",          // maps to supplier_price
    supplier_amount: "",      // maps to amount1 (calculated)
    buyer: "",
    buyer_po: "",
    buyer_pp: "",             // maps to pp_value
    contract: "",
    currency: "",             // maps to currency_value
    amount_received: "",      // maps to amount_recvd (calculated)
    transportation: "",
    transporter: "",
    redex_company: "",
    redex_amount: "",
    despatcho: "",
    despatcho_amount: "",
    shipping_line: "",
    shipping_line_amount: "",
    port: "",
    port_no: "",
    party: {
        party_id: "",
        party_type: ""
    },
    others: "",
	pod: "India",
    final_amount: "",
    remarks: "Done",
    // NEW calculated/needed fields:
    supplier_price: "",       // M (SP)
    sp: "",                   // O (NFE value per unit)
    nfe_value: "",            // P = H × O
    expense_type: "",
    // Calculation helper fields
    //amount1: "",              // N = H × M
    amount2: "",              // Q (P?) = H × T
    amount_received_calc: ""  // W = U × W
};

    const emptyRowxxx = {
        type: "EXW",
        invoice_no: currentYear.toString(),
        date: new Date().toISOString().split('T')[0],
        booking_no: "",
        tara: "",
        container_no: "",
        seal_no: "",
        qty: "",
        material: "",
        supplier: "",
        supplier_po: "",
        supplier_nfe: "",
        supplier_pp: "",
        supplier_amount: "",
        buyer: "",
        buyer_po: "",
        buyer_pp: "",
        contract: "",
        currency: "",
        amount_received: "",
        transportation: "",
        transporter: "",
        redex_company: "",
        redex_amount: "",
        despatcho: "",
        despatcho_amount: "",
        shipping_line: "",
        shipping_line_amount: "",
        port: "",
        port_no: "",
		party: {
            party_id: "",
            party_type: "",
			party_amount:""
        }, // Changed to object
        others: "",
        final_amount: "",
        remarks: ""
    };
    
    const dispatch = useDispatch();
    
    // Separate state for form entries and ledger list
    //const [rows, setRows] = useState([{ ...emptyRow }]);// show single row
	const [rows, setRows] = useState(
    Array.from({ length: 10 }, () => ({
        ...emptyRow,
        id: crypto.randomUUID()
    }))
);
    const [ledgers, setLedgers] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const popupRef = useRef(null);
    const inputRefs = useRef({});
    
    // State for dropdown data
    const [party, setParty] = useState([]);
	const [materials, setMaterials] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [buyers, setBuyers] = useState([]);
	const [banks, setBanks] = useState([]);
    const [ports, setPorts] = useState([]);
    const [redex, setRedex] = useState([]);
    const [transporters, setTransporters] = useState([]);
    const [despatcho, setDespatcho] = useState([]);
	const [shipping, setShipping] = useState([]);
	
	const requiredFields = [
    "type",
    "invoice_no",
    "date",
    "booking_no",
    "tara",
    "container_no",
    "seal_no",
    "qty",
    "material",
    "supplier",
    "supplier_po",
    "supplier_nfe",
    "supplier_pp",
    "supplier_amount",
	//"amount1",
    "buyer",
    "buyer_po",
    "buyer_pp",
    "contract",
    "currency",
    "amount_received",
    "transportation",
    "transporter",
    "redex_company",
    "redex_amount",
    "despatcho",
    "despatcho_amount",
    "shipping_line",
    "shipping_line_amount",
    "port",
    "port_no",
	"others",
    "pod",
    "party",
    "final_amount"
];

const optionalFields = [
    "others",
    "remarks"
];
const calculateRow = (row) => {
    const num = (v) => {
        const n = Number(v);
        return isNaN(n) ? 0 : n;
    };

    // Letter-mapped values
    const H = num(row.qty);                       // QTY
    const M = num(row.supplier_pp);               // Supplier PP (price per unit)
    const O = num(row.sp);                        // SP
    const T = num(row.buyer_pp);                  // Buyer PP
    const U = num(row.currency);                  // Currency rate
    const W = num(row.amount_received);           // Amount Recd
    const Y = num(row.transportation);            // Transportation
    const AA = num(row.redex_amount);             // Redex Amount
    const AC = num(row.despatcho_amount);         // Despacho Amount
    const AE = num(row.shipping_line_amount);     // Shipping Line Amt
    const AG = num(row.port_no);                  // Port No
    const AI = num(row.others);                   // Others

    // N = H × M  (Supplier Amount)
    const N = H * M;

    // P = H × O  (NFE Value)
    const P = H * O;

    // Amount2 = H × T  (Buyer Amount)
    const amount2 = H * T;

    // Amount Recd (calculated) = amount2 × U
    const amount_received_calc = amount2 * U;

    // Final = W − M2 − Y − AA − AC − AE − AG − AI
    // (M2 is N = supplier amount)
    //const final_amount = W - N - Y - AA - AC - AE - AG - AI;
	const final_amount = W - N - Y - AA - AC - AE - AG - AI;

    return {
        ...row,
		supplier_amount: N.toFixed(2),
        nfe_value: P.toFixed(2),
        amount2: amount2.toFixed(2),
        //amount_received_calc: amount_received_calc.toFixed(2),
		amount_received: amount_received_calc.toFixed(2), // ✅ mirror it
        final_amount: final_amount.toFixed(2)
    };
};

const isRowStarted = (row) => {
    // Fields that are automatically populated
    // should NOT make an empty row "started"
    const userFields = requiredFields.filter(
        field => field !== "type" && field !== "date"
    );

    return userFields.some(field => {
        const value = row[field];

        if (typeof value === "object" && value !== null) {
            return Object.values(value).some(
                v =>
                    v !== undefined &&
                    v !== null &&
                    String(v).trim() !== ""
            );
        }

        return (
            value !== undefined &&
            value !== null &&
            String(value).trim() !== ""
        );
    });
};




const isRowComplete = (row) => {
    return requiredFields.every(field => {
        const value = row[field];

        if (typeof value === "object" && value !== null) {
            return Object.values(value).every(
                v => v !== undefined && v !== null && String(v).trim() !== ""
            );
        }

        return value !== undefined &&
               value !== null &&
               String(value).trim() !== "";
    });
};
    
    const [popup, setPopup] = useState({
        show: false,
        row: -1,
        field: "",
        x: 0,
        y: 0,
        data: [],
        searchText: ""
    });
    
    // API URLs
    const ledger_url = "https://eshaastra.in/api/ledgers";
    const bank_url = "https://eshaastra.in/api/banks";
	const buyer_url = "https://eshaastra.in/api/buyers";
    const port_url = "https://eshaastra.in/api/ports";
    const redex_url = "https://eshaastra.in/api/redex";
    const despatcho_url = "https://eshaastra.in/api/despatcho";
    const shipping_url = "https://eshaastra.in/api/shipping";
    const supplier_url = "https://eshaastra.in/api/supplier";
    const material_url = "https://eshaastra.in/api/materials";
	const transporter_url = "https://eshaastra.in/api/transporter";
    
    // Fetch functions
    const getBanks = async () => {
        try {
            const response = await axios.get(bank_url);
            setBanks(response.data.data || []);
            //console.log("Fetched banks:", response.data.data);
        } catch (error) {
            console.error("Error fetching ledgers:", error);
            toast.error("Failed to fetch banks");
        }
    };
	
	const getLedgers = async () => {
        try {
            const response = await axios.get(ledger_url);
            setLedgers(response.data.data || []);
            //console.log("Fetched ledgers:", response.data.data);
        } catch (error) {
            console.error("Error fetching ledgers:", error);
            toast.error("Failed to fetch ledgers");
        }
    };
    
    const getBuyers = async () => {
        try {
            const response = await axios.get(buyer_url);
            setBuyers(response.data.data || []);
            //console.log("Fetched buyers:", response.data.data);
        } catch (error) {
            console.error("Error fetching buyers:", error);
        }
    };
    
    const getPorts = async () => {
        try {
            const response = await axios.get(port_url);
            setPorts(response.data.data || []);
            //console.log("Fetched ports:", response.data.data);
        } catch (error) {
            console.error("Error fetching ports:", error);
        }
    };
    
    const getRedex = async () => {
        try {
            const response = await axios.get(redex_url);
            setRedex(response.data.data || []);
            //console.log("Fetched redex:", response.data.data);
        } catch (error) {
            console.error("Error fetching redex:", error);
        }
    };
    
    const getDespatcho = async () => {
        try {
            const response = await axios.get(despatcho_url);
            setDespatcho(response.data.data || []);
            //console.log("Fetched despatcho:", response.data.data);
        } catch (error) {
            console.error("Error fetching despatcho:", error);
        }
    };
    
    const getSuppliers = async () => {
        try {
            const response = await axios.get(supplier_url);
            setSuppliers(response.data.data || []);
            //console.log("Fetched suppliers:", response.data.data);
        } catch (error) {
            console.error("Error fetching suppliers:", error);
        }
    };
	
	const getShipping = async () => {
        try {
            const response = await axios.get(shipping_url);
            setShipping(response.data.data || []);
            //console.log("Fetched shipping:", response.data.data);
        } catch (error) {
            console.error("Error fetching shipping:", error);
        }
    };
    
    const getMaterials = async () => {
        try {
            const response = await axios.get(material_url);
            setMaterials(response.data.data || []);
            //console.log("Fetched materials:", response.data.data);
        } catch (error) {
            console.error("Error fetching materials:", error);
        }
    };
    
    const getTransporters = async () => {
        try {
            const response = await axios.get(transporter_url);
            setTransporters(response.data.data || []);
            //console.log("Fetched transporters:", response.data.data);
        } catch (error) {
            console.error("Error fetching transporters:", error);
        }
    };
    
    useEffect(() => {
        setIsLoading(true);
        Promise.all([
            getBanks(),
			getLedgers(),
            getBuyers(),
            getPorts(),
            getRedex(),
            getDespatcho(),
			getShipping(),
            getSuppliers(),
            getMaterials(),
            getTransporters()
        ]).finally(() => {
            setIsLoading(false);
        });
    }, []);
	
	//const [party, setParty] = useState([]);
useEffect(() => {

    const allParty = [
    ...suppliers.map(item => ({
        ...item,
        type: "Supplier"
    })),

    ...banks.map(item => ({
        ...item,
        type: "Bank"
    })),
	...buyers.map(item => ({
        ...item,
        type: "Buyer"
    })),

    ...transporters.map(item => ({
        ...item,
        type: "Transporter"
    })),

    ...ports.map(item => ({
        ...item,
        type: "Port"
    })),

    ...materials.map(item => ({
        ...item,
        type: "Material"
    })),

    ...redex.map(item => ({
        ...item,
        type: "Redex"
    })),

    ...despatcho.map(item => ({
        ...item,
        type: "Despatcho"
    })),
	...shipping.map(item => ({
        ...item,
        type: "Shipping"
    }))
];

    setParty(allParty);

}, [
    banks,
	suppliers,
    buyers,
    transporters,
    ports,
    materials,
    redex,
    despatcho,
	shipping
]);
/*useEffect(() => {

    const allParty = [
        ...suppliers,
        ...buyers,
        ...transporters,
        ...redex,
        ...despatcho,
        ...ports,
        ...materials
    ];

    setParty(allParty);

}, [
    suppliers,
    buyers,
    transporters,
    redex,
    despatcho,
    ports,
    materials
]);*/
    //console.log(party);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closePopup();
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [popup.show]);
    
    const handleScroll = () => {
        if (popup.show) {
            updatePopupPosition();
        }
    };
    
    const updatePopupPosition = () => {
    const inputKey = `${popup.row}-${popup.field}`;
    const inputElement = inputRefs.current[inputKey];

    if (inputElement) {
        const rect = inputElement.getBoundingClientRect();

        setPopup(prev => ({
            ...prev,
            x: rect.left,
            y: rect.bottom
        }));
    }
};
    
    const openPopup = (e, row, field) => {
        e.preventDefault();
        e.stopPropagation();
        
        let data = [];
        let fieldDisplayName = field;
        
        switch(field) {
            case "material":
                data = materials;
                fieldDisplayName = "Material";
                break;
            case "supplier":
                data = suppliers;
                fieldDisplayName = "Supplier";
                break;
            case "buyer":
                data = buyers;
                fieldDisplayName = "Buyer";
                break;
            case "transporter":
                data = transporters;
                fieldDisplayName = "Transporter";
                break;
            case "port":
                data = ports;
                fieldDisplayName = "Port";
                break;
            case "redex_company":
                data = redex;
                fieldDisplayName = "Redex";
                break;
            case "despatcho":
                data = despatcho;
                fieldDisplayName = "Despatcho";
                break;
			case "shipping_line":
                data = shipping;
                fieldDisplayName = "Shipping";
                break;
			case "party":
				data = party;
				break;
            default:
                data = [];
        }
        
        if (!data || data.length === 0) {
            toast.info(`No ${fieldDisplayName} data available.`);
            return;
        }
        
        const rect = e.target.getBoundingClientRect();
        const x = rect.left;
        //const y = rect.bottom + window.scrollY;
		const y = rect.bottom; // no scrollY
		//style={{ position: 'fixed', top: popup.y, ... }};
        
        setPopup({
            show: true,
            row,
            field,
            x: x,
            y: y,
            data: data,
            searchText: ""
        });
    };
    
    const closePopup = () => {
        setPopup({
            ...popup,
            show: false
        });
    };
    
	const selectPopupItem = (item) => {
    const { row, field } = popup;

    setRows(prevRows => {
        const updatedRows = [...prevRows];

        if (field === "party") {
            // Party is stored as an object
            updatedRows[row] = {
                ...updatedRows[row],
                party: {
                    party_id: item._id,
                    party_type: item.type
                }
            };
        } else {
            // All other popup fields store only the selected ID
            updatedRows[row] = {
                ...updatedRows[row],
                [field]: item._id
            };
        }

        return updatedRows;
    });

    closePopup();
};

    
    const handlePopupSearch = (e) => {
        setPopup({
            ...popup,
            searchText: e.target.value
        });
    };
    
    const getFilteredPopupData = () => {
        if (!popup.searchText) return popup.data;
        
        return popup.data.filter(item =>
            item.name && item.name.toLowerCase().includes(popup.searchText.toLowerCase())
        );
    };
    
    const addRow = () => {
    setRows(prevRows => [
        ...prevRows,
        {
            ...emptyRow,
            id: crypto.randomUUID(),
            date: new Date().toISOString().split("T")[0]
        }
    ]);
};
    
    const removeRow = (index) => {
        if (rows.length === 1) {
            toast.warning("At least one row is required");
            return;
        }
        setRows(rows.filter((_, i) => i !== index));
    };
	
	const handleTypeChange = (index, value) => {
    setRows(prevRows => {
        const updated = [...prevRows];
        const row = { ...updated[index], type: value };

        if (value === "EXW") {
            // Lock and zero-out supplier/buyer financial fields
            row.supplier_po = "0";
            row.supplier_nfe = "0";
            row.supplier_pp = "0";
            row.supplier_amount = "0";
            row.sp = "0";
            row.nfe_value = "0";
        } else if (value === "FOB") {
            // Clear them so user can enter
            row.supplier_po = "";
            row.supplier_nfe = "";
            row.supplier_pp = "";
            row.supplier_amount = "";
            row.sp = "";
            row.nfe_value = "";
        }

        updated[index] = calculateRow(row);
        return updated;
    });
};
    
    /*const handleChange = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };*/
	
	const handleChange = (index, field, value) => {

    setRows(prevRows => {

        const updatedRows = [...prevRows];

        const updatedRow = {
            ...updatedRows[index],
            [field]: value
        };

        updatedRows[index] = calculateRow(updatedRow);

        return updatedRows;
    });
};

// ✅ POD is a separate field, not `type`
    const handlePodChange = (index, value) => {
        setRows((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], pod: value };
            return updated;
        });
    };
	const handleSubmit = async (e) => {
    e.preventDefault();

    // Only rows where all required fields are completed
    const completeRows = rows.filter(row => isRowComplete(row));

    console.log("All rows:", rows);
    console.log("Completed rows only:", completeRows);

    // Nothing is completed
    if (completeRows.length === 0) {
        toast.warning("Please complete at least one ledger entry.");
        return;
    }

    setIsSubmitting(true);

    try {
        console.log("Rows being saved:", completeRows);

        // Submit ONLY completed rows
        await dispatch(
            addLedger({
                entries: completeRows
            })
        ).unwrap();

        toast.success(
            `Successfully created ${completeRows.length} ledger ${
                completeRows.length === 1 ? "entry" : "entries"
            }`
        );

        // Reset form back to 10 empty rows
        setRows(
            Array.from({ length: 10 }, () => ({
                ...emptyRow,
                id: crypto.randomUUID(),
                date: new Date().toISOString().split("T")[0]
            }))
        );

        await getLedgers();

    } catch (error) {
        console.error("Error:", error);

        toast.error(
            error?.message || "Failed to create ledger entries"
        );

    } finally {
        setIsSubmitting(false);
    }
};
	const handleSubmitxxx = async (e) => {
    e.preventDefault();

    // Only rows where the user has entered something
    const startedRows = rows.filter(row => isRowStarted(row));
	
	console.log(startedRows);

    // Rows where user started entering data but
    // did not complete all required fields
    const incompleteRows = startedRows.filter(
        row => !isRowComplete(row)
    );
	console.log(incompleteRows);
    // Rows where every required field is filled
    const completeRows = startedRows.filter(
        row => isRowComplete(row)
    );
	console.log(completeRows);
    // Nothing entered
    if (startedRows.length === 0) {
        toast.warning("Please enter at least one ledger entry.");
        return;
    }

    // User started a row but did not complete it
    if (incompleteRows.length > 0) {
        toast.error(
            `Please complete all fields in ${incompleteRows.length} incomplete row(s).`
        );
        return;
    }

    // Save ONLY complete rows
    setIsSubmitting(true);

    try {
        console.log("Rows being saved:", completeRows);

        await dispatch(
            addLedger({
                entries: completeRows
            })
        ).unwrap();

        toast.success(
            `Successfully created ${completeRows.length} ledger ${
                completeRows.length === 1 ? "entry" : "entries"
            }`
        );

        // Reset back to 10 empty rows
        setRows(
            Array.from({ length: 10 }, () => ({
                ...emptyRow,
                id: crypto.randomUUID(),
                date: new Date().toISOString().split("T")[0]
            }))
        );

        await getLedgers();

    } catch (error) {
        console.error("Error:", error);

        toast.error(
            error?.message || "Failed to create ledger entries"
        );

    } finally {
        setIsSubmitting(false);
    }
};
    
    
    
    const deleteLedger = async (id) => {
        const result = await Swal.fire({
            title: "Delete Ledger?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "Cancel"
        });
        
        if (!result.isConfirmed) return;
        
        try {
            await dispatch(removeLedger(id)).unwrap();
            toast.success("Ledger deleted successfully.");
            await getLedgers();
        } catch (error) {
            toast.error(error.message || "Delete failed.");
        }
    };
	
	const getDisplayName = (value, data) => {
    if (!value) return "";

    // Normal populated object
    if (typeof value === "object") {

        // Party object
        if (value.party_id) {
            const item = data.find(d => d._id === value.party_id);
            return item ? item.name : "";
        }

        // Normal populated MongoDB object
        if (value.name) {
            return value.name;
        }

        // Object containing _id
        if (value._id) {
            const item = data.find(d => d._id === value._id);
            return item ? item.name : "";
        }

        return "";
    }

    // Value is MongoDB ID
    if (typeof value === "string") {
        const item = data.find(d => d._id === value);
        return item ? item.name : "";
    }

    return "";
};
    
    
    // Filter ledgers for display
    const filteredItems = ledgers.filter((item) => {
        const searchTerm = filterText.toLowerCase();
        return (
            (item.material?.name || item.material || "").toLowerCase().includes(searchTerm) ||
            (item.supplier?.name || item.supplier || "").toLowerCase().includes(searchTerm) ||
            (item.buyer?.name || item.buyer || "").toLowerCase().includes(searchTerm) ||
            (item.container_no || "").toLowerCase().includes(searchTerm) ||
            (item.invoice_no || "").toLowerCase().includes(searchTerm)
        );
    });
    
    const columns = [
        {
            name: "#",
            width: "70px",
            cell: (row, index) => index + 1
        },
        {
            name: "Type",
			width: "100px",
            selector: row => row.type || "-",
            sortable: true
        },
        {
            name: "Date",
			width: "100px",
            selector: row => {
                if (!row.date) return "-";
                try {
                    const dateObj = new Date(row.date);
                    if (isNaN(dateObj.getTime())) return "-";
                    return dateObj.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    });
                } catch (error) {
                    return "-";
                }
            },
            sortable: true
        },
        {
            name: "Invoice No",
			width: "100px",
            selector: row => row.invoice_no || "-",
            sortable: true
        },
        {
            name: "Container No",
			width: "100px",
            selector: row => row.container_no || "-",
            sortable: true
        },
        {
            name: "Material",
			width: "100px",
            selector: row => {
                // Check if material is populated object or ID
                if (row.material && typeof row.material === 'object' && row.material.name) {
                    return row.material.name;
                }
                if (row.material && typeof row.material === 'string') {
                    const item = materials.find(m => m._id === row.material);
                    return item ? item.name : row.material;
                }
                return row.material || "-";
            },
            sortable: true
        },
        {
            name: "Supplier",
			width: "100px",
            selector: row => {
                if (row.supplier && typeof row.supplier === 'object' && row.supplier.name) {
                    return row.supplier.name;
                }
                if (row.supplier && typeof row.supplier === 'string') {
                    const item = suppliers.find(s => s._id === row.supplier);
                    return item ? item.name : row.supplier;
                }
                return row.supplier || "-";
            },
            sortable: true
        },
        {
            name: "Buyer",
			width: "100px",
            selector: row => {
                if (row.buyer && typeof row.buyer === 'object' && row.buyer.name) {
                    return row.buyer.name;
                }
                if (row.buyer && typeof row.buyer === 'string') {
                    const item = buyers.find(b => b._id === row.buyer);
                    return item ? item.name : row.buyer;
                }
                return row.buyer || "-";
            },
            sortable: true
        },
        {
            name: "Port",
			width: "100px",
            selector: row => {
                if (row.port && typeof row.port === 'object' && row.port.name) {
                    return row.port.name;
                }
                if (row.port && typeof row.port === 'string') {
                    const item = ports.find(p => p._id === row.port);
                    return item ? item.name : row.port;
                }
                return row.port || "-";
            },
            sortable: true
        },
        {
            name: "Amount",
			width: "100px",
            selector: row => {
                const amount = row.final_amount || row.supplier_amount || 0;
                return Number(amount).toFixed(2);
            },
            sortable: true
        },
        {
            name: "Action",
            width: "100px",
            cell: (row) => (
                <div className="dropdown">
                    <button
                        className="btn btn-primary btn-sm dropdown-toggle"
                        data-bs-toggle="dropdown"
                    >
                        Actions
                    </button>
                    <ul className="dropdown-menu">
                        <li>
                            <Link
                                className="dropdown-item"
                                to={`/dashboard/editledger/${row._id}`}
                            >
                                <i className="bi bi-pencil-square me-2"></i>
                                Edit
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="dropdown-item"
                                to={`/dashboard/ledgers/${row._id}`}
                            >
                                <i className="bi bi-eye me-2"></i>
                                View
                            </Link>
                        </li>
                        <li>
                            <hr className="dropdown-divider" />
                        </li>
                        <li>
                            <button
                                className="dropdown-item text-danger"
                                onClick={() => deleteLedger(row._id)}
                            >
                                <i className="bi bi-trash me-2"></i>
                                Delete
                            </button>
                        </li>
                    </ul>
                </div>
            )
        }
    ];
    
    // Get the input key for ref
    const getInputKey = (index, field) => {
        return `${index}-${field}`;
    };
    
    return (
        <div style={{ position: 'relative' }}>
            {/* Entry Form */}
            <div className="card shadow border-0 mb-4">
                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                        <i className="bi bi-plus-circle me-2"></i>
                        Ledger Entries
                    </h5>
                    {isLoading && (
                        <span className="badge bg-light text-dark">
                            <i className="bi bi-arrow-repeat me-1 spinner"></i>
                            Loading...
                        </span>
                    )}
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="table-responsive ledger-wrapper">
                            <table className="table table-bordered table-sm ledger-table">
                                <thead className="table-light">
								{/* Excel Column Letters */}
								
    {/* Excel Column Letters */}
    <tr className="excel-column-row">
        {[
            "A", "B", "C", "D", "E", "F", "G", "H", "I",
            "J", "K", "L", "M", "N(HxM)", "O", "P(HxO)", "Q", "R",
            "S", "T", "U(HxT)", "V", "W", "X(UxW)", "Y", "Z",
            "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI","AJ"
        ].map((letter) => (
            <th key={letter}>{letter}</th>
        ))}
    </tr>

    {/* Actual Column Names */}
                                    <tr>
                                        <th>Type</th>
                                        <th>Invoice No</th>
                                        <th>Date</th>
                                        <th>Booking No</th>
                                        <th>Tara</th>
                                        <th>Container No</th>
                                        <th>Seal No</th>
                                        <th>QTY</th>
                                        <th className="w-lg">Material</th>
                                        <th>Supplier</th>
                                        <th>Supplier PO</th>
                                        <th>Supplier NFE</th>
                                        <th>Supplier PP</th>
                                        <th>Supplier Amount</th>
                                        <th className="w-lg">Buyer</th>
                                        <th>Buyer PO</th>
                                        <th>Buyer PP</th>
                                        <th>Contract</th>
                                        <th>Currency</th>
                                        <th>Amount Received</th>
                                        <th>Transportation</th>
                                        <th>Transporter</th>
                                        <th className="w-lg">Redex Company</th>
                                        <th>Redex Amount</th>
                                        <th className="w-lg">Despatcho</th>
                                        <th>Despatcho Amount</th>
                                        <th className="w-lg">Shipping Line</th>
                                        <th>Shipping Line Amt</th>
                                        <th className="w-lg">Port</th>
                                        <th>Port No</th>
                                        <th>Party</th>
                                        <th>Others</th>
										<th>POD</th>
                                        <th>Final Amount</th>
                                        <th>Remarks</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr className={
        isRowComplete(row)
            ? "ledger-row-complete"
            : isRowStarted(row)
                ? "ledger-row-working"
                : "ledger-row-empty"
    }
    key={row.id || index}>
                                            <td>
                                                <select
    className="form-select form-select-sm"
    value={row.type}
    onChange={(e) => handleTypeChange(index, e.target.value)}
    required
>
    <option value="EXW">EXW</option>
    <option value="FOB">FOB</option>
</select>
                                            </td>
                                            <td>
                                                <input
    type="text"
    className="form-control form-control-sm"
    placeholder="Invoice No"
    value={row.invoice_no}
    onChange={(e) =>
        handleChange(index, "invoice_no", e.target.value)
    }
/>
                                            </td>
                                            <td>
                                                <input 
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={row.date}
                                                    onChange={(e) => handleChange(index, "date", e.target.value)}
                                                    required
                                                />
                                            </td>
                                            <td>
                                                <CustomInput
    type="number"
    className="form-control form-control-sm booking_no"
    name="booking_no"
    value={row.booking_no}
    onChange={(e) => handleChange(index, "booking_no", e.target.value)}
    placeholder="Booking No"
/>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm tara"
                                                    placeholder="Tara"
                                                    value={row.tara}
                                                    onChange={(e) => handleChange(index, "tara", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <CustomInput
    type="number"
    className="form-control form-control-sm container_no"
    name="container_no"
    value={row.container_no}
    onChange={(e) => handleChange(index, "container_no", e.target.value)}
    placeholder="Container No"
/>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm seal_no"
                                                    placeholder="Seal No"
                                                    value={row.seal_no}
                                                    onChange={(e) => handleChange(index, "seal_no", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                
                                                <CustomInput
    type="number"
    className="form-control form-control-sm"
    name="qty"
    value={row.qty}
    onChange={(e) => handleChange(index, "qty", e.target.value)}
    placeholder="QTY"
/>
                                            </td>
                                            <td className="w-lg">
                                                <input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "material")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={materials.length === 0 ? "No materials" : "Select"}
                                                    value={getDisplayName(row.material, materials)}
                                                    onClick={(e) => openPopup(e, index, "material")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: materials.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: materials.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    required
                                                    disabled={materials.length === 0}
                                                />
                                            </td>
                                            <td className="w-lg">
                                                <input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "supplier")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={suppliers.length === 0 ? "No suppliers" : "Select"}
                                                    value={getDisplayName(row.supplier, suppliers)}
                                                    onClick={(e) => openPopup(e, index, "supplier")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: suppliers.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: suppliers.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    required
                                                    disabled={suppliers.length === 0}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Supplier PO"
                                                    value={row.supplier_po}
                                                    onChange={(e) => handleChange(index, "supplier_po", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Supplier NFE"
                                                    value={row.supplier_nfe}
                                                    onChange={(e) => handleChange(index, "supplier_nfe", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Supplier PP"
                                                    value={row.supplier_pp}
                                                    onChange={(e) => handleChange(index, "supplier_pp", e.target.value)}
                                                />
                                            </td>
                                            {/* Supplier Amount (amount1) — calculated */}
<td>
    <input
        type="number"
        step="0.01"
        className="form-control form-control-sm"
        placeholder="Supplier Amount"
        value={row.supplier_amount}
        readOnly
        style={{ backgroundColor: '#f5f5f5' }}
    />
</td>
                                            <td className="w-lg">
                                                <input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "buyer")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={buyers.length === 0 ? "No buyers" : "Select"}
                                                    value={getDisplayName(row.buyer, buyers)}
                                                    onClick={(e) => openPopup(e, index, "buyer")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: buyers.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: buyers.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    required
                                                    disabled={buyers.length === 0}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Buyer PO"
                                                    value={row.buyer_po}
                                                    onChange={(e) => handleChange(index, "buyer_po", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Buyer PP"
                                                    value={row.buyer_pp}
                                                    onChange={(e) => handleChange(index, "buyer_pp", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Contract"
                                                    value={row.contract}
                                                    onChange={(e) => handleChange(index, "contract", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <CustomInput
    type="number"
    className="form-control form-control-sm"
    name="currency"
    value={row.currency}
    onChange={(e) => handleChange(index, "currency", e.target.value)}
    placeholder="Currency"
/>
                                            </td>
                                            {/* Amount Received — calculated (if using option b) */}
<td>
    <input
        type="number"
        step="0.01"
        className="form-control form-control-sm"
        placeholder="Amount Received"
        value={row.amount_received_calc || row.amount_received}
        readOnly
        style={{ backgroundColor: '#f5f5f5' }}
    />
</td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Transportation"
                                                    value={row.transportation}
                                                    onChange={(e) => handleChange(index, "transportation", e.target.value)}
                                                />
                                            </td>
                                            <td className="w-lg">
                                                <input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "transporter")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={transporters.length === 0 ? "No transporters" : "Select"}
                                                    value={getDisplayName(row.transporter, transporters)}
                                                    onClick={(e) => openPopup(e, index, "transporter")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: transporters.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: transporters.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    disabled={transporters.length === 0}
                                                />
                                            </td>
                                            <td className="w-lg">
                                                <input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "redex_company")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={redex.length === 0 ? "No redex" : "Select"}
                                                    value={getDisplayName(row.redex_company, redex)}
                                                    onClick={(e) => openPopup(e, index, "redex_company")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: redex.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: redex.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    disabled={redex.length === 0}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control form-control-sm"
                                                    placeholder="Redex Amount"
                                                    value={row.redex_amount}
                                                    onChange={(e) => handleChange(index, "redex_amount", e.target.value)}
                                                />
                                            </td>
                                            <td className="w-lg">
                                                <input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "despatcho")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={despatcho.length === 0 ? "No despatcho" : "Select"}
                                                    value={getDisplayName(row.despatcho, despatcho)}
                                                    onClick={(e) => openPopup(e, index, "despatcho")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: despatcho.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: despatcho.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    disabled={despatcho.length === 0}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control form-control-sm"
                                                    placeholder="Despatcho Amount"
                                                    value={row.despatcho_amount}
                                                    onChange={(e) => handleChange(index, "despatcho_amount", e.target.value)}
                                                />
                                            </td>
                                            <td>
											<input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "shipping_line")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={shipping.length === 0 ? "No shipping line" : "Select"}
                                                    value={getDisplayName(row.shipping_line, shipping)}
                                                    onClick={(e) => openPopup(e, index, "shipping_line")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: shipping.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: shipping.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    disabled={shipping.length === 0}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control form-control-sm"
                                                    placeholder="Shipping Line Amt"
                                                    value={row.shipping_line_amount}
                                                    onChange={(e) => handleChange(index, "shipping_line_amount", e.target.value)}
                                                />
                                            </td>
                                            <td className="w-lg">
                                                <input type="text"
                                                    ref={el => inputRefs.current[getInputKey(index, "port")] = el}
                                                    className="form-control form-control-sm"
                                                    placeholder={ports.length === 0 ? "No ports" : "Select"}
                                                    value={getDisplayName(row.port, ports)}
                                                    onClick={(e) => openPopup(e, index, "port")}
                                                    readOnly
                                                    style={{ 
                                                        cursor: ports.length === 0 ? 'not-allowed' : 'pointer', 
                                                        backgroundColor: ports.length === 0 ? '#f5f5f5' : '#f8f9fa' 
                                                    }}
                                                    disabled={ports.length === 0}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Port No"
                                                    value={row.port_no}
                                                    onChange={(e) => handleChange(index, "port_no", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input type="text"
    ref={el =>
        inputRefs.current[getInputKey(index, "party")] = el
    }
    
    className="form-control form-control-sm"
    placeholder={
        party.length > 0
            ? "Select Party"
            : "No Party Available"
    }
    value={getDisplayName(row.party, party)}
    onClick={(e) => {
        if (party.length > 0) {
            openPopup(e, index, "party");
        }
    }}
    readOnly
    disabled={party.length === 0}
    style={{
        cursor: party.length > 0 ? "pointer" : "not-allowed",
        backgroundColor: party.length > 0 ? "#fff" : "#f8f9fa"
    }}
/>
                                            </td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Others"
                                                    value={row.others}
                                                    onChange={(e) => handleChange(index, "others", e.target.value)}
                                                />
                                            </td>
											{/* ✅ POD now bound to row.pod, not row.type */}
                                            <td>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={row.pod}
                                                    onChange={(e) =>
                                                        handlePodChange(
                                                            index,
                                                            e.target.value
                                                        )
                                                    }
                                                    required
                                                >
                                                    <option value="India">India</option>
                                                    <option value="Nigeria">Nigeria</option>
                                                </select>
                                            </td>
                                            {/* Final Amount — calculated */}
<td>
    <input
        type="number"
        step="0.01"
        className="form-control form-control-sm"
        placeholder="Final Amount"
        value={row.final_amount}
        readOnly
        style={{ backgroundColor: '#f5f5f5' }}
        title="W - N - Y - AA - AC - AE - AG - AI"
    />
</td>
                                            <td>
                                                <input type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Remarks"
                                                    value={row.remarks}
                                                    onChange={(e) => handleChange(index, "remarks", e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => removeRow(index)}
                                                    disabled={rows.length === 1}
                                                >
                                                    ×
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        <div className="d-flex justify-content-between mt-3">
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                onClick={addRow}
                            >
                                <i className="bi bi-plus-circle me-1"></i>
                                Add Row
                            </button>
                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={isSubmitting || isLoading}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Saving...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-save me-2"></i>
                                        Save All Entries
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            
            {/* Popup Component */}
            {popup.show && popup.data.length > 0 && (
                <div 
                    ref={popupRef}
                    className="popup-select"
                    style={{
                        position: 'fixed',
                        top: popup.y,
                        left: Math.min(popup.x, window.innerWidth - 320),
                        zIndex: 9999,
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        maxHeight: '300px',
                        width: '280px',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <div style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                        <input type="text"
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={`Search ${popup.field}...`}
                            value={popup.searchText}
                            onChange={handlePopupSearch}
                            autoFocus
                        />
                    </div>
                    <div style={{ 
                        overflowY: 'auto', 
                        maxHeight: '250px',
                        padding: '4px 0'
                    }}>
                        {getFilteredPopupData().length > 0 ? (
                            getFilteredPopupData().map((item, idx) => (
                                <div
                                    key={idx}
                                    className="popup-item"
                                    onClick={() => selectPopupItem(item)}
                                    style={{
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f0f0f0';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    {item.name}
                                </div>
                            ))
                        ) : (
                            <div style={{ padding: '16px', textAlign: 'center', color: '#666' }}>
                                No results found
                            </div>
                        )}
                    </div>
                </div>
            )}
            
            
            <style jsx>{`
                .popup-item:hover {
                    background-color: #f0f0f0;
                }
                .popup-item:active {
                    background-color: #e0e0e0;
                }
                .w-lg {
                    min-width: 120px;
                }
                .spinner {
                    animation: spin 1s linear infinite;
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}

export default LedgerTable;